var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3332 16.0001C29.3332 23.3639 23.3636 29.3334 15.9998 29.3334C8.63604 29.3334 2.6665 23.3639 2.6665 16.0001C2.6665 8.63628 8.63604 2.66675 15.9998 2.66675C23.3636 2.66675 29.3332 8.63628 29.3332 16.0001Z",
    fill: "#FFB8B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9549 10.6376C19.6058 9.9867 20.6615 9.98668 21.3124 10.6376C21.963 11.2884 21.963 12.3441 21.3124 12.995L18.3309 15.9755L21.3094 18.955C21.9603 19.6059 21.9603 20.6615 21.3094 21.3124C20.6586 21.963 19.6037 21.9631 18.953 21.3124L15.9735 18.3329L12.995 21.3124C12.3442 21.963 11.2893 21.963 10.6385 21.3124C9.98768 20.6615 9.98768 19.6059 10.6385 18.955L13.617 15.9755L10.6366 12.995C9.98573 12.3441 9.98573 11.2885 10.6366 10.6376C11.2874 9.98694 12.3422 9.9869 12.993 10.6376L15.9735 13.618L18.9549 10.6376Z",
    fill: "#912B2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusError);
export default __webpack_public_path__ + "static/media/status-error.f48dc155d1ad75c6482913c42dcab53d.svg";
export { ForwardRef as ReactComponent };